/* Folliva hair analysis — content.
   2026-10-06: every visible text here can be changed in Customize (Hair analysis page → the quiz section's blocks);
   a text changed there wins over the one here. These are the defaults. Logic lives in fl-quiz.js.
   [[text]] = highlighted words. Keep option "v" values stable: the profile rules and the data log use them. */
window.FLQ_DATA = {
  version: "2026-10-06",

  intro: {
    eyebrow: "Folliva · Hair analysis",
    title: "Find out what's thinning your hair, and [[how to stop it without a pill]].",
    points: ["About 2 minutes, all taps", "Your hair report and plan at the end", "No email needed to see it"],
    sub: "About 2 minutes. A personal analysis at the end. No email needed to see it.",
    cta: "Start my analysis",
    proxy: "Answering for your partner, son or brother?",
    skip: "Skip to the product", skipTop: "Skip to product",
    note: "Your answers are anonymous.",
    /* ad links ?start=a1|a2|a3 (2026-10-07): this profile's headline; its "Skip" link opens the profile's result page (?p=aX) */
    starts: {
      a2: "Off finasteride and losing hair again? Find out [[what to do next]].",
      a3: "More scalp on top? Find out why, and [[how to stop it without a pill]].",
      a1: "Still losing hair on fin or minoxidil? Find [[the gap in your routine]]."
    }
  },

  proxyNote: "You're answering for him. The result will speak to him directly, so you can show it to him.",

  questions: {
    who: {
      type: "single", title: "Who is this analysis for?",
      options: [
        { v: "man", label: "Me", sub: "I'm a man", icon: "me" },
        { v: "proxy", label: "My partner, son or brother", sub: "I'm answering for him", icon: "proxy" }
      ]
    },
    age: {
      type: "single", title: "How old are you?", titleProxy: "How old is he?",
      options: [
        { v: "u18", label: "Under 18", end: "minor" },
        { v: "18_24", label: "18–24" },
        { v: "25_34", label: "25–34" },
        { v: "35_44", label: "35–44" },
        { v: "45_54", label: "45–54" },
        { v: "55p", label: "55+" }
      ],
      why: "The younger it starts, the more hair there is to protect. Age also changes what we'd recommend."
    },
    where: {
      type: "single", title: "Where are you noticing changes?", icons: true,
      options: [
        { v: "temples", label: "Hairline and temples", icon: "temples" },
        { v: "crown", label: "Crown", sub: "The top of your head", icon: "crown" },
        { v: "both", label: "Both hairline and crown", icon: "both" },
        { v: "diffuse", label: "Thinning all over", icon: "diffuse" },
        { v: "none", label: "Nowhere yet", sub: "I want to stay ahead of it", icon: "none" }
      ],
      why: "Where hair goes first shows the pattern. Temples and crown together are the classic sign of DHT-driven hair loss."
    },
    when: {
      type: "single", title: "When did you start noticing?",
      options: [
        { v: "months", label: "In the last few months" },
        { v: "year", label: "In the last year" },
        { v: "y1_3", label: "1–3 years ago" },
        { v: "y3p", label: "More than 3 years ago" }
      ]
    },
    amount: {
      type: "single", title: "How much have you lost?",
      options: [
        { v: "little", label: "A little", sub: "Only I notice" },
        { v: "some", label: "Some", sub: "People close to me notice" },
        { v: "lot", label: "A lot", sub: "It's obvious to everyone" }
      ]
    },
    family: {
      type: "single", title: "Does hair loss run in your family?",
      options: [
        { v: "father", label: "Yes, on my father's side" },
        { v: "mother", label: "Yes, on my mother's side" },
        { v: "both", label: "On both sides" },
        { v: "no", label: "Not that I know of" }
      ],
      why: "Male pattern hair loss can come from either side of the family. What you inherit is how sensitive your follicles are to DHT."
    },
    tried: {
      type: "multi", title: "What have you tried so far?", sub: "Choose all that apply.",
      options: [
        { v: "fin_oral", label: "Finasteride tablets", sub: "The most common hair-loss pill (Propecia)" },
        { v: "dut", label: "Dutasteride", sub: "A stronger pill from the same family" },
        { v: "fin_top", label: "Topical finasteride", sub: "A spray or lotion version of finasteride" },
        { v: "minox", label: "Minoxidil", sub: "Rogaine / Regaine: foam, liquid or tablets" },
        { v: "natural", label: "Natural options", sub: "Rosemary, saw palmetto, pumpkin seed, special shampoos" },
        { v: "supp", label: "Supplements", sub: "Biotin, gummies" },
        { v: "device", label: "Microneedling, laser or PRP" },
        { v: "nothing", label: "Nothing yet", exclusive: true }
      ]
    },
    fin: {
      type: "single", title: "How did finasteride or dutasteride go for you?", sub: "The hair-loss pills (or their spray versions).",
      options: [
        { v: "nonresp", label: "I'm still on it, but I'm still losing hair" },
        { v: "stacker", label: "I'm on it and it works", sub: "I want more protection or regrowth" },
        { v: "sides", label: "I stopped because of side effects" },
        { v: "feared", label: "I stopped because I was worried about side effects" },
        { v: "other", label: "I stopped for another reason", sub: "Cost, hassle, my doctor" }
      ]
    },
    sides: {
      type: "multi", title: "What did you notice?", sub: "Choose all that apply.",
      options: [
        { v: "libido", label: "Lower sex drive" },
        { v: "ed", label: "Erection problems" },
        { v: "energy", label: "Low energy or fatigue" },
        { v: "fog", label: "Brain fog" },
        { v: "mood", label: "Low mood or anxiety" },
        { v: "chest", label: "Chest tenderness" },
        { v: "other", label: "Something else" }
      ],
      why: "So we can show you exactly how our approach differs from what you took."
    },
    whynot: {
      type: "single", title: "What's kept you from finasteride so far?", sub: "Finasteride is the most common hair-loss pill.",
      options: [
        { v: "sides_fear", label: "I'm worried about sexual side effects" },
        { v: "lifelong", label: "I don't want a daily pill for the rest of my life" },
        { v: "access", label: "My doctor said no, or I can't get a prescription" },
        { v: "natural", label: "I'd rather try natural options" },
        { v: "unaware", label: "I didn't know it was an option" }
      ]
    },
    situ: {
      type: "multi", title: "Do any of these apply to you?", sub: "Choose all that apply.",
      options: [
        { v: "trt", label: "I'm on TRT", sub: "Testosterone replacement therapy" },
        { v: "aas", label: "I train enhanced", sub: "Steroids or SARMs, now or planned" },
        { v: "ht_done", label: "I've had a hair transplant" },
        { v: "ht_plan", label: "I'm planning a hair transplant" },
        { v: "baby", label: "We're trying for a baby" },
        { v: "none", label: "None of these", exclusive: true }
      ],
      why: "Extra testosterone and anabolic compounds raise the DHT pressure on your follicles. A transplant moves hair, but it doesn't stop the loss around it. Each one changes what we'd recommend. No judgement."
    },
    worry: {
      type: "single", title: "What worries you most right now?",
      options: [
        { v: "worse", label: "That it keeps getting worse" },
        { v: "noticed", label: "People noticing", sub: "Photos, dates, work" },
        { v: "sides", label: "Side effects from treatment" },
        { v: "money", label: "Wasting more money on things that don't work" },
        { v: "transplant", label: "Losing the hair I paid for", only: "transplant" },
        { v: "lifelong", label: "Taking something for the rest of my life" }
      ]
    },
    goal: {
      type: "single", title: "What would feel like a win six months from now?",
      options: [
        { v: "keep", label: "No more hair loss", sub: "Keep what I have" },
        { v: "regrow", label: "Regrow some of what I've lost" },
        { v: "thicker", label: "Thicker, fuller-looking hair" },
        { v: "transplant", label: "Protect my transplant result", only: "transplant" },
        { v: "forget", label: "Stop thinking about my hair" }
      ]
    },
    expect: {
      type: "single", title: "How soon do you expect to see a difference?",
      options: [
        { v: "weeks", label: "Within a few weeks" },
        { v: "m2_3", label: "In 2–3 months" },
        { v: "m4_6", label: "In 4–6 months" },
        { v: "patient", label: "I know it takes time", sub: "I just want it to work" }
      ],
      why: "Honest answer: hair grows slowly. Shedding settles first, the first fine hairs usually show around month 3–4, and month 6 is the earliest fair verdict. That's why we plan in months, not weeks.",
      whyH: "Good to know"
    },
    email: {
      type: "email", title: "Want your hair report by email?",
      sub: "Your report and plan, plus 3 short emails for your profile: the first weeks, the shedding phase, and how to judge it at day 120. Optional.",
      placeholder: "Your email",
      consent: "Yes, email me tips and offers for my hair profile. I agree that Folliva Labs stores my answers with my email for this.",
      privacy: "Privacy policy",
      cta: "Email me my report",
      skip: "No thanks, show my result",
      thanks: "Done. Watch your inbox."
    }
  },

  ends: {
    woman: {
      eyebrow: "A quick note",
      title: "Folliva DHT Blocker is made for men.",
      text: "Antiandrogens aren't suitable for women who are or could become pregnant, so we don't offer it to women. A dermatologist can check what's behind your hair loss. In women it's often not DHT at all.",
      cta: "Back to the start"
    },
    minor: {
      eyebrow: "A quick note",
      title: "Folliva is for adults, 18 and over.",
      text: "At your age hair changes can have many causes. Talk to a doctor or a dermatologist before you use any DHT blocker. Come back any time after you turn 18.",
      cta: "Back to the start"
    }
  },

  pattern: {
    eyebrow: "Your pattern",
    area: {
      temples: "Hairline and temples", crown: "The crown", both: "Hairline and crown", diffuse: "Thinning all over"
    },
    when: {
      months: "noticed in the last few months", year: "noticed in the last year", y1_3: "going for 1–3 years", y3p: "going for more than 3 years"
    },
    family: {
      father: "hair loss on your father's side", mother: "hair loss on your mother's side", both: "hair loss on both sides of your family", no: ""
    },
    named: "That pattern has a name: [[male pattern hair loss]]. And one main driver: [[DHT]].",
    explain: "DHT is a hormone your body makes from testosterone. In men who inherit sensitive hair roots (follicles), it [[slowly shrinks them]] until they stop growing visible hair. It doesn't stop on its own. The good news: [[it's a known target]].",
    noneTitle: "No visible loss yet{fam}. Good timing: [[it's far easier to keep hair than to regrow it]].",
    noneFam: ", but [[it runs in your family]]",
    diffuseNew: "Sudden thinning all over can be DHT, but also stress, illness or a new medication. If it started suddenly, see a doctor first."
  },

  loading: {
    title: "Building your hair profile…",
    steps: ["Reading your pattern", "Checking what you've tried", "Matching how DHT affects you", "Putting your plan together"],
    lines: ["Comparing your answers with 4,020 men's stories…", "Mapping where DHT is acting…", "Checking what you've already tried…", "Building your plan…"]
  },

  recap: {
    title: "Here's what we know about your hair so far:",
    card: "Your hair",
    groups: { hair: "Hair changes", background: "Background", tried: "What you've tried", situ: "Your situation", matters: "What matters to you" },
    next: "Now, let's see what men like you are noticing.",
    k: { brand: "Hair report", noticed: "Noticed", amount: "Amount", family: "Family history", age: "Age", worry: "Worry", goal: "Goal", onIt: " · on it", stopped: " · stopped" },
    fam: { father: "Father's side", mother: "Mother's side", both: "Both sides", no: "None known" }
  },

  ready: {
    title: "Good news: [[your plan is ready]].",
    good: "Good news.",
    line: "Your plan is ready.",
    sub: "Built from your answers.",
    cta: "See my plan"
  },

  /* Folliva Clear (2026-10-04): customer results right after the hair report */
  reviews: {
    label: "Customer results",
    title: "What customers are [[noticing]].",
    note: "Photos and words shared by customers. Individual results vary.",
    cta: "See my hair profile",
    cases: [
      { img: "ba1", name: "Marco D.", quote: "Shedding in the shower pretty much stopped right away. Honestly amazed it worked." },
      { img: "ba2", name: "Ryan P.", quote: "The only thing that has ever worked for me. Be patient and consistent, around month four I really saw it." },
      { img: "ba3", name: "Tom W.", quote: "The hairs along my hairline are clearly filling in, my confidence is back, and no side effects at all." },
      { img: "ba4", name: "Adam K.", quote: "Only six weeks in and my hair already feels thicker. Tiny baby hairs are coming through." },
      { img: "p1b", img2: "p1a", name: "Chris L.", quote: "Started with half a ml a day and went up to a full ml four months ago. The shedding stopped almost from the start." }
    ],
    badge: "Verified buyer",
    before: "Before", after: "After"
  },

  /* why us, before the plan */
  hands: {
    label: "Why Folliva",
    title: "You're in [[good hands]].",
    sub: "Here's what you get when you start with us.",
    points: [
      { h: "No sexual side effects", t: "Folliva blocks DHT at the hair follicle instead of lowering it in your whole body. Your sex drive is left alone." },
      { h: "A plan built from your answers", t: "Your size, routine and timeline come from your pattern, your stage and what you've already tried." },
      { h: "Honest from day one", t: "We tell you what to expect month by month, including the early shedding most brands never mention." },
      { h: "You stay in control", t: "Autoship you can pause or cancel anytime, online. No contracts, no calls." }
    ],
    cta: "Show me my plan"
  },

  /* plan chooser: straight to checkout */
  plan: {
    label: "Your plan",
    title: "Choose how long you're [[covered]].",
    sub: "Most men quit in month 1 or 2, before anything can show. Pick the plan that gets you further.",
    /* 2026-10-06 evening (Oliver): the cards show these instead of "about €X a day" (that moved next to "Due today") */
    reach: { "50 ml": "Try the routine for a month", "100 ml": "Get past the shedding phase", "150 ml": "When the first fine hairs usually show" },
    best: "Best value",
    autoship: "Autoship & save + free shipping", autoshipNote: "Delivered every {n}. Pause or cancel anytime.",
    oneTime: "One-time purchase", oneTimeNote: "No subscription.",
    today: "Due today", dueDay: "({price} a day)", then: "then {price} every {n} · cancel anytime",
    cta: "Continue to checkout",
    fine: "Secure checkout · Free EU shipping on this order",
    guarantee: "[[120-day money-back guarantee.]]",
    error: "Something went wrong. Opening the product page instead…",
    /* 2026-10-16 (Oliver): Free Starter Kit row under the cards. Which gifts come with the picked size = what checkout adds
       (Cart drawer → Free Starter Kit gifts at checkout); kitText2 / kitWas2 = both gifts, kitText1 / kitWas1 = one */
    kitOn: "true", kitTitle: "+ Free Starter Kit", kitText2: "Derma roller + 120-day program", kitText1: "120-day program · roller with 2 or 3 months",
    kitWas2: "€30", kitWas1: "€15", kitFree: "Free", kitImg1: "", kitImg2: "",
    badge: "−{pct}%", perMonth: "/month", save: "Save {amount}", card1: "{n} month", cardN: "{n} months", every1: "month", everyN: "{n} months"
  },

  labels: {
    next: "Next", cont: "Continue", back: "Back", skip: "Skip",
    profile: "Your hair profile", pattern: "Pattern", stage: "Stage", driver: "Main driver", gap: "Your gap",
    stages: ["Prevention", "Early", "Moderate", "Advanced"],
    stageNote: "Our estimate from your answers. Not a medical diagnosis.",
    painEyebrow: "Sound familiar?", notYou: "Not quite your situation?", personaliseShort: "Take the 2-minute analysis",
    guarantee: "[[120-day money-back guarantee.]]",
    mechEyebrow: "What's happening", mechTap: "Tap a number to see what it means.",
    mechCaption: "However DHT is made, it does its damage in one place: the receptor on the hair follicle. That is the spot Folliva DHT Blocker blocks.", proofEyebrow: "You're not alone", sources: "Sources",
    planEyebrow: "Your plan", whyFits: "Why it [[fits you]]", howTo: "How to [[use it]]", expect: "What to expect, [[honestly]]",
    startPlan: "Start my plan", faq: "Your questions", retake: "Not you? Retake the analysis",
    revealCta: "What can I do about it?", revealEyebrow: "Your hair report",
    urgency: "The good news: shrinking follicles can still recover. [[Lost ones can't.]] Every month without DHT protection, more of them shrink.",
    goalShort: { keep: "Goal: keep what I have", regrow: "Goal: regrow", thicker: "Goal: thicker hair", transplant: "Goal: protect my grafts", forget: "Goal: stop worrying" },
    perDay: "about {price} a day", quizFine: "This quiz is not a medical assessment.",
    personalise: "Take the 2-minute analysis to personalise this", recommended: "Recommended for you",
    driverInherited: "Inherited DHT sensitivity", driverPattern: "DHT sensitivity", driverCheck: "Unclear, see a doctor first",
    driverTrt: "Extra testosterone → more DHT", driverAas: "Androgens + DHT sensitivity",
    disclaimer: "This analysis is based on what you told us. It is not a medical diagnosis or medical advice.",
    whyAsk: "Why we ask", worth: "Worth knowing", noLoss: "No visible loss yet", nothing: "Nothing yet", glossH: "Words, made simple",
    emailInvalid: "Please enter a valid email.", emailTick: "Please tick the box so we can send it."
  },

  /* offer page (after the report) */
  offerPage: {
    product: "Folliva DHT Blocker", supply: "{n}-month supply", perMonth: "/month", for1: "{price} for {n} month", forN: "{price} for {n} months",
    autoship: "Autoship & save · cancel anytime", stage: "{stage} stage",
    chips: ["No sexual side effects", "Doesn't lower your DHT", "Doesn't lower testosterone"],
    trust: ["120-day money-back guarantee", "Pause or cancel anytime", "Free EU shipping on your first order"]
  },

  /* short versions of answers (analysis screen, hair report) */
  short: {
    fin: { nonresp: "On it, still losing hair", stacker: "On it and it works, wants more", sides: "Stopped: side effects", feared: "Stopped: worried about side effects", other: "Stopped: other reasons" },
    situ: { trt: "On TRT", aas: "Trains enhanced", ht_done: "Had a hair transplant", ht_plan: "Planning a hair transplant", baby: "Trying for a baby" }
  },

  /* the sentence on the report screen, built from the answers */
  mirror: {
    subj: { temples: "Your hairline and temples", crown: "Your crown", both: "Your hairline and crown", diffuse: "Your hair" },
    allOver: "all over",
    whenOne: { months: "started thinning{all} in the last few months", year: "started thinning{all} in the last year", y1_3: "has been thinning{all} for one to three years", y3p: "has been thinning{all} for more than three years", now: "is thinning{all}" },
    whenMany: { months: "started thinning in the last few months", year: "started thinning in the last year", y1_3: "have been thinning for one to three years", y3p: "have been thinning for more than three years", now: "are thinning" },
    fam: { father: "and hair loss runs on your father's side", mother: "and hair loss runs on your mother's side", both: "and hair loss runs on both sides of your family" },
    noneFam: "You don't see hair loss yet, but it runs in your family.",
    noneNo: "You don't see hair loss yet, and you want to keep it that way.",
    drug: { fin_oral: "Finasteride", dut: "Dutasteride", fin_top: "Topical finasteride" },
    sides: { libido: "a lower sex drive", ed: "erection problems", energy: "fatigue", fog: "brain fog", mood: "low mood", chest: "chest tenderness" },
    sidesNone: "side effects",
    dropout: "{drug} came with {list}, so you stopped. Your hair loss didn't stop when you did.",
    stacker: "{drug} is holding the line, and you want more than holding.",
    veteran: "You're on {meds}, and you're still losing ground.",
    meds: { fin_oral: "finasteride", dut: "dutasteride", fin_top: "topical finasteride", minox: "minoxidil" },
    medsNone: "finasteride",
    pillwary: {
      fear: "You haven't started finasteride, because you're not willing to gamble with your sex life.",
      lifelong: "You haven't started finasteride, because you don't want a pill every day for the rest of your life.",
      feared: "You stopped finasteride before it could cause trouble.",
      access: "You can't get finasteride right now.",
      unaware: "You haven't tried a DHT blocker yet."
    },
    tried: "You've tried {list}.",
    other: { minox: "minoxidil", natural: "natural remedies", supp: "supplements", device: "microneedling or laser" },
    transplantDone: "You've invested in a hair transplant.",
    transplantPlan: "You're planning a hair transplant.",
    minoxPlus: "Minoxidil, plus a few natural remedies, is your line of defence.",
    minoxOnly: "Minoxidil is your only line of defence.",
    gear: "You train enhanced{fin}.", gearFin: ", and you already run {drug}",
    trt: "You're on TRT{extra}.", trtSides: ", and finasteride already let you down", trtFear: ", and finasteride is the last thing you want to risk",
    naturalTried: "You've given the natural route a fair try.",
    naturalPref: "You'd rather keep it natural.",
    notnow: "You're trying for a baby.",
    worry: { worse: "that it keeps getting worse", noticed: "people noticing", sides: "side effects", money: "wasting more money", transplant: "losing the hair you paid for", lifelong: "being on something for life" },
    worryLine: "What worries you most: {w}."
  },

  /* labels on the 1-2-3 follicle picture */
  mech3d: { enzyme: "Testosterone → DHT", receptor: "DHT receptor", growth: "Growth phase", graft: "Graft", bypass: "DHT-derived" },

  /* tap-to-explain words (shown to visitors who are new to the topic) */
  gloss: {
    "DHT": "A hormone your body makes from testosterone. It is what shrinks hair follicles.",
    "finasteride": "The most common hair-loss pill (Propecia). It lowers DHT in your whole body.",
    "dutasteride": "A stronger pill from the same family as finasteride.",
    "minoxidil": "Rogaine / Regaine. It helps hair grow, but it does not block DHT.",
    "receptor": "The \"docking spot\" on a hair follicle. When DHT plugs in, the follicle shrinks.",
    "follicle": "The tiny root a hair grows from.",
    "androgenetic alopecia": "The medical name for male pattern hair loss.",
    "TRT": "Testosterone replacement therapy.",
    "5-alpha-reductase": "The enzyme that turns testosterone into DHT. Finasteride blocks it."
  },

  howTo: [
    "Six to seven pumps is roughly 1–1.5 ml. That is the daily dose.",
    "Part the hair and put it on the scalp, not the hair. The receptors are in the skin.",
    "Let it dry fully. Nothing to rinse.",
    "Once a day, same time, ideally at night. Photograph the same spot, in the same light, once a month."
  ],

  timeline: [
    { t: "Weeks 0–4", h: "A routine, not results yet", ic: "calendar", d: "Nothing visible, and possibly more shedding than usual as follicles reset their cycle. It reads like failure. It usually isn't." },
    { t: "Months 1–2", h: "The shedding settles", ic: "drop", d: "The shedding settles. Loss slows before anything grows. This is where most people quit." },
    { t: "Months 3–4", h: "First fine hairs", ic: "leaf", d: "Fine, pale hairs at the temples and hairline. Easy to miss without the baseline photo you took in week one." },
    { t: "Month 6+", h: "Your honest verdict", ic: "camera", d: "The earliest point a fair verdict is possible. Compare photographs, not memories." }
  ],

  /* Profiles. Priority (same as the avatar research codebook):
     gear > trt > dropout > notnow > transplant > pillwary(fear) > veteran(stacker) > veteran(nonresp) > minox > natural > pillwary(other) */
  profiles: {

    veteran: {
      name: "On treatment, still losing ground",
      tag: "Men who've done everything right, and still watch the mirror.",
      gap: "Your routine lowers DHT. Nothing in it guards the follicle.",
      inter: "You've done what you were told. Finasteride [[lowers]] how much DHT your body makes. It doesn't [[guard the follicle]] against the DHT that's still there. || If you're still losing hair, that's [[the gap]].",
      mech: {
        title: "Your routine works on one step. [[DHT still reaches the follicle.]]",
        pins: [
          { at: "growth", h: "Thinner hair, every cycle", t: "The DHT that's still there keeps shortening each growth cycle. That's the loss you still see in the mirror.", tone: "info" },
          { at: "receptor", h: "Folliva DHT Blocker", t: "Blocks the DHT that's still there, at the follicle's receptor. The layer you're missing.", tone: "ours" },
          { at: "enzyme", h: "Finasteride / dutasteride", t: "Lowers how much DHT your body makes. You already have this step covered.", tone: "have" }
        ]
      },
      proof: {
        title: "You're not a lost cause. [[You're missing a layer.]]",
        stats: [
          { n: "≈64%", t: "is how much finasteride 1 mg lowers DHT in the scalp. A lot, but not all of it.", src: "Drake et al., J Am Acad Dermatol, 1999" },
          { n: "17%", t: "of the 4,020 men we studied who were looking for a non-pill DHT blocker were still losing hair on finasteride or dutasteride.", src: "Folliva research: Reddit, Oct 2025–Oct 2026" }
        ],
        voice: "The same story keeps coming up: years on the gold standard, and the temples still go."
      },
      offer: {
        h: "Add the layer your routine is [[missing]].",
        sub: "Keep what works. Add a 5% DHT blocker that acts where finasteride doesn't: at the follicle's receptor.",
        size: "150 ml", sizeWhy: "150 ml is 90 days: exactly the window you need to judge a new layer fairly."
      },
      reasons: [
        { h: "A different mechanism", t: "Finasteride and dutasteride cut DHT production. Folliva blocks DHT at the receptor. The two work at different points." },
        { h: "Fits the routine you already run", t: "Keep your pill. Spray Folliva at night. If you use topical minoxidil, put it on in the morning." },
        { h: "Judged properly", t: "Three months is the honest test. Same photo, same light, every four weeks." }
      ],
      note: "Already on finasteride or dutasteride? Keep taking it. Don't stop a treatment without talking to your doctor.",
      faq: [
        { q: "Can I use it with finasteride, dutasteride or minoxidil?", a: "Yes. Most men in your situation keep their pill as usual, spray Folliva on the scalp at night and use minoxidil in the morning." },
        { q: "Does it replace finasteride?", a: "It works differently, so think of it as an addition. Don't stop finasteride or dutasteride without talking to your doctor." },
        { q: "What strength is it?", a: "5%. Six to seven sprays, about 1–1.5 ml, once a day." },
        { q: "How long until I know?", a: "Give it three months before you judge it. Take a photo in the same light every four weeks. That's how you'll actually see it." },
        { q: "Can I pause or cancel?", a: "Yes. Autoship can be paused or cancelled anytime." }
      ],
      variants: {
        stacker: {
          name: "Ready for the next layer",
          tag: "Men whose finasteride works, and who want more than holding the line.",
          gap: "You're holding the line. Nothing in your routine defends the follicle itself.",
          inter: "Finasteride is holding the line, and [[that's the hard part done]]. It works on the enzyme that makes DHT. The next layer works somewhere finasteride doesn't reach: [[the follicle's receptor]].",
          proofTitle: "Holding is the hard part. [[Now add the layer that defends.]]",
          offerH: "Your next layer, [[right at the follicle]]."
        }
      }
    },

    dropout: {
      name: "After finasteride",
      tag: "Men who stopped finasteride for good reasons, and still want their hair.",
      gap: "No DHT protection since you stopped.",
      inter: "It worked on your hair. It [[didn't work for the rest of you]]. || You're not imagining it, and you're not alone. In our research into 4,000+ men looking for a non-pill DHT blocker, quitting finasteride over side effects was one of the [[three most common reasons]].",
      mech: {
        title: "Finasteride worked on your [[whole body]]. The problem is [[at the follicle]].",
        pins: [
          { at: "growth", h: "Thinning again", t: "Since you stopped, DHT is back to full strength at the follicle, and each cycle grows back thinner.", tone: "info" },
          { at: "receptor", h: "Folliva DHT Blocker", t: "Blocks DHT at the follicle's receptor. It doesn't lower your DHT, so there are no sexual side effects.", tone: "ours" },
          { at: "enzyme", h: "Finasteride", t: "Lowered DHT everywhere in your body. That's where your side effects came from, and why you stopped.", tone: "stopped" }
        ]
      },
      proof: {
        title: "You're not imagining it. [[And you're not out of options.]]",
        stats: [
          { n: "21%", t: "of the 4,020 men we studied who were looking for a non-pill DHT blocker had quit finasteride over side effects.", src: "Folliva research: Reddit, Oct 2025–Oct 2026" },
          { n: "2025", t: "is the year the EU added a patient alert card to every finasteride 1 mg pack.", src: "EMA PRAC review, May 2025; European Commission decision, Aug 2025" }
        ],
        voice: "Men describe it the same way: it worked on their hair, and not on the rest of them."
      },
      offer: {
        h: "Block DHT again, [[without finasteride]].",
        sub: "A 5% topical DHT blocker. It doesn't lower your testosterone or the DHT your body makes. It blocks DHT where it shrinks hair: at the follicle.",
        size: "100 ml", sizeWhy: "100 ml is 60 days: enough to get past the shedding phase. Pause or cancel anytime."
      },
      reasons: [
        { h: "No sexual side effects", t: "Finasteride lowered DHT across your whole body, and that's where your side effects came from. Folliva doesn't lower your DHT. It blocks DHT at the follicle." },
        { h: "For men who won't trade libido for a hairline", t: "That trade is what made you stop. This works at a different point: the receptor in the follicle, not your body's DHT supply." },
        { h: "Start on your terms", t: "Once a day, at night. Autoship can be paused or cancelled anytime. No lock-in." }
      ],
      note: "If you notice anything you don't like, stop and tell us. That's what the pause button is for.",
      faq: [
        { q: "Is this topical finasteride?", a: "No. It's a different compound with a different mechanism: it blocks DHT at the receptor instead of stopping your body from making it." },
        { q: "Will my side effects come back?", a: "It doesn't work the way finasteride does: it doesn't lower your testosterone or your body's DHT. Everyone is different, though. If you notice anything you don't like, stop using it and tell us." },
        { q: "Can I use it with minoxidil?", a: "Yes. Minoxidil in the morning, Folliva at night." },
        { q: "How long until I see a difference?", a: "Shedding usually settles first. Visible change takes three to six months. Judge it at month three, with photos." },
        { q: "Can I stop anytime?", a: "Yes. Autoship can be paused or cancelled anytime." }
      ]
    },

    pillwary: {
      name: "Starting early, without the pill",
      tag: "Men who want to act early, without a pill for the next 20 years.",
      gap: "Nothing is blocking DHT yet, and time is the one thing you can't buy back.",
      inter: "Not wanting to risk your sex life for your hairline [[isn't paranoia]]. || It's one of the most common reasons men put treatment off. The catch: [[follicles don't wait]]. Every month of \"I'll decide later\" is a month of slow shrinking.",
      mech: {
        title: "Two ways to stop DHT. [[Only one lowers it in your whole body.]]",
        pins: [
          { at: "growth", h: "Thinner hair, every cycle", t: "DHT shortens each growth cycle, so hair grows back finer. The earlier you stop it, the more you keep.", tone: "info" },
          { at: "receptor", h: "Folliva DHT Blocker", t: "Blocks DHT at the follicle's receptor. It doesn't lower your DHT, so there are no sexual side effects.", tone: "ours" },
          { at: "enzyme", h: "Finasteride", t: "A daily pill that lowers DHT across your whole body. That's where its sexual side effects come from.", tone: "avoid" }
        ]
      },
      proof: {
        title: "Wanting another route [[isn't paranoia]].",
        stats: [
          { n: "59%", t: "of US men aged 18–24 say going bald terrifies them.", src: "YouGov, 2020" },
          { n: "20%", t: "of the 4,020 men we studied who were looking for a non-pill DHT blocker hadn't started finasteride because of the side effects.", src: "Folliva research: Reddit, Oct 2025–Oct 2026" }
        ],
        voice: "The same line comes up again and again: \"I want to stop it early. I'm just not taking that pill.\""
      },
      offer: {
        h: "Stop it early. [[No sexual side effects.]]",
        sub: "A max-strength 5% DHT blocker for your scalp. It doesn't lower your DHT or testosterone like finasteride does, so there are no sexual side effects.",
        size: "100 ml", sizeWhy: "100 ml is 60 days: enough to build the habit and get past the first weeks."
      },
      reasons: [
        { h: "No sexual side effects", t: "Finasteride lowers DHT across your whole body. That's where its side effects come from. Folliva doesn't lower your DHT. It blocks DHT at the follicle." },
        { h: "No pill for the next 20 years", t: "A spray at night instead of a daily pill. Stop whenever you want: if you do, DHT simply goes back to work on the follicle over the following months." },
        { h: "Zero risk to try", t: "Your first order comes with a 120-day money-back guarantee. Autoship can be paused or cancelled anytime." }
      ],
      note: "",
      faq: [
        { q: "Am I too young?", a: "Folliva is for adults, 18 and over. Hair loss that starts in your twenties is common, and it's easier to keep hair than to regrow it." },
        { q: "Is it as strong as finasteride?", a: "They work differently, and no study has compared them head to head. Finasteride lowers DHT; Folliva blocks it at the follicle." },
        { q: "Do I have to use it forever?", a: "Only as long as you want the effect. If you stop, DHT goes back to work on the follicle over the following months." },
        { q: "What about side effects?", a: "It doesn't lower your DHT or testosterone the way finasteride does, which is why there are no sexual side effects. Some men notice mild scalp dryness at first. If you notice anything you don't like, stop and tell us." },
        { q: "How long until I see results?", a: "Three to six months. Take photos in the same light every four weeks." }
      ],
      variants: {
        lifelong: {
          offerH: "Stop it early. [[No pill for life.]]",
          inter: "[[A pill every day for 20 years]] is a big ask. You're not wrong to want another route. But [[waiting is a decision too]]: follicles shrink slowly, and it's easier to keep hair than to regrow it."
        },
        feared: {
          inter: "You stopped before it could cause trouble, and [[that's a reasonable call]]. The catch: DHT didn't stop with you. [[Follicles don't wait]]."
        },
        access: {
          name: "No prescription needed",
          inter: "Can't get finasteride? [[You still have options.]] A topical DHT blocker works at a different point, and it's [[not a prescription pill]]."
        },
        unaware: {
          inter: "Most men find out about DHT [[after]] they've lost a lot. You're finding out [[before]]. That's the best position to be in."
        },
        early: {
          name: "Ahead of it",
          tag: "Men who want to keep their hair before there's anything to regrow.",
          offerH: "Keep what you have. [[Start before it shows.]]",
          gap: "Nothing is blocking DHT yet. The best time to start is before it shows.",
          inter: "Most men find out about DHT [[after]] they've lost a lot. You're finding out [[before]]. That's the best position to be in."
        }
      }
    },

    transplant: {
      name: "Protecting your transplant",
      tag: "Men who paid for their hairline, and want to keep the rest.",
      gap: "Your grafts are DHT-resistant. The hair around them isn't.",
      inter: "Your grafts came from the back of your head, where hair is [[resistant to DHT]]. The hair around them [[isn't]]. || That's why the hair next to a transplant keeps thinning, and why surgeons talk about protecting your [[native hair]].",
      mech: {
        title: "The transplant moved the hair. [[It didn't stop the hair loss.]]",
        pins: [
          { at: "growth", h: "Your grafts", t: "Taken from the back of the head, where hair is naturally resistant to DHT. They keep growing.", tone: "have" },
          { at: "receptor", h: "Your native hair", t: "Still sensitive to DHT. Folliva DHT Blocker blocks DHT at its receptor, so the hair around your grafts holds on.", tone: "ours" },
          { at: "enzyme", h: "Finasteride", t: "The usual advice after surgery: a daily pill that lowers DHT across your whole body, sexual side effects included.", tone: "avoid" }
        ],
        caption: "Grafts shrug off DHT. The hair around them can't. Its receptor is where Folliva DHT Blocker works."
      },
      proof: {
        title: "Protecting it costs [[less than a second transplant]].",
        stats: [
          { n: "4 in 10", t: "transplant patients who talk about medication online fear finasteride or have had side effects on it.", src: "Folliva research: r/HairTransplants, Oct 2025–Oct 2026" },
          { n: "€2–12k", t: "is what a hair transplant typically costs. Protecting the result costs a fraction of that.", src: "Clinic price ranges collected in Folliva research, 2026" }
        ],
        voice: "Many men say the same thing after surgery: told to take finasteride for life, and not keen."
      },
      offer: {
        h: "Protect the hair [[you paid for]].",
        sub: "A max-strength 5% DHT blocker for the native hair around your grafts. No sexual side effects, because it doesn't lower your DHT like finasteride.",
        size: "150 ml", sizeWhy: "150 ml is 90 days: the shortest window to judge it fairly."
      },
      reasons: [
        { h: "Guards your native hair", t: "Grafts hold up to DHT. The hair next to them is what keeps thinning, and that's what Folliva protects." },
        { h: "No finasteride for life", t: "Protect your native hair without a pill that lowers DHT across your whole body. One spray routine at night, alongside minoxidil if you use it." },
        { h: "Less than a second transplant", t: "A year of Folliva on Autoship costs about €610, roughly €1,70 a day. A second transplant costs €2,000–12,000." }
      ],
      note: "Start when your surgeon says your scalp has healed. Already on finasteride? Keep it unless your doctor says otherwise.",
      faq: [
        { q: "When can I start after surgery?", a: "Once your surgeon clears your scalp, usually after the grafts have healed. Ask your clinic." },
        { q: "Do I need it if my surgeon didn't prescribe anything?", a: "Your grafts are safe either way. The native hair around them isn't, which is why many men add a DHT blocker." },
        { q: "Can I use it with finasteride or minoxidil?", a: "Yes. Keep your current routine and add Folliva at night." },
        { q: "How long until I see a difference?", a: "Judge it at three to six months, with photos in the same light." }
      ]
    },

    minox: {
      name: "The missing half",
      tag: "Men who know minoxidil helps, and that it can't do it alone.",
      gap: "Minoxidil grows hair. Nothing in your routine blocks DHT.",
      inter: "Minoxidil keeps follicles in the growth phase. It does [[nothing about DHT]], the thing shrinking them. || That's why gains often [[stall after 6–12 months]].",
      mech: {
        title: "Minoxidil pushes growth. [[DHT keeps shrinking the follicle anyway.]]",
        pins: [
          { at: "growth", h: "Minoxidil", t: "Keeps follicles in the growth phase. What you already use. It doesn't touch DHT.", tone: "have" },
          { at: "receptor", h: "Folliva DHT Blocker", t: "Blocks DHT at the follicle's receptor. The half that's missing.", tone: "ours" },
          { at: "enzyme", h: "Finasteride", t: "Lowers DHT across your whole body, and that's where its sexual side effects come from. You can block DHT without it.", tone: "info" }
        ],
        caption: "Minoxidil pushes the follicle to grow. DHT keeps shrinking it at the receptor. Folliva DHT Blocker blocks that receptor."
      },
      proof: {
        title: "You're fighting [[with one hand]].",
        stats: [
          { n: "1 in 4", t: "posts in the biggest minoxidil community mention finasteride, dutasteride or DHT.", src: "Folliva research: r/minoxidil, Oct 2025–Oct 2026" },
          { n: "0", t: "is how much DHT minoxidil blocks. It isn't designed to. It works on blood flow and the growth phase.", src: "Minoxidil mechanism of action" }
        ],
        voice: "A common story: minoxidil grew it back, then it stopped working."
      },
      offer: {
        h: "Add the half that [[blocks DHT]].",
        sub: "Keep your minoxidil. Add a 5% DHT blocker for the part minoxidil can't touch.",
        size: "100 ml", sizeWhy: "100 ml is 60 days: set it up next to your minoxidil and make it a habit."
      },
      reasons: [
        { h: "The other half", t: "Minoxidil wakes follicles up. DHT keeps shrinking them. Folliva blocks DHT at the follicle." },
        { h: "Easy to layer", t: "Minoxidil in the morning, Folliva at night." },
        { h: "Keep your gains", t: "Blocking DHT is what protects the hair minoxidil helped you grow." }
      ],
      note: "",
      faq: [
        { q: "Can I stop minoxidil?", a: "Not suddenly: hair grown with minoxidil can shed if you stop. Add Folliva first, and talk to a doctor before dropping anything." },
        { q: "Will I shed again?", a: "Some men notice a short shed in the first weeks of any new routine. It usually settles." },
        { q: "How do I combine them?", a: "Minoxidil in the morning, Folliva at night, each on a dry scalp." },
        { q: "How long until I see a difference?", a: "Judge it at three to six months, with photos in the same light." }
      ]
    },

    gear: {
      name: "Training enhanced",
      tag: "Lifters who aren't giving up the cycle, or the hairline.",
      gap: "Finasteride can't block DHT-derived compounds.",
      inter: "Few things put more [[androgen pressure]] on your follicles than training enhanced. || Finasteride blocks [[one route]]: testosterone turning into DHT. Compounds that are already DHT-derived go straight past it. That's why enhanced lifters look for a [[receptor-level]] blocker.",
      mech: {
        title: "Finasteride blocks one route. [[The receptor is where they all land.]]",
        pins: [
          { at: "growth", h: "Thinner hair, faster", t: "The androgens in your stack keep hitting the follicle, so each growth cycle gets shorter.", tone: "info" },
          { at: "receptor", h: "Folliva DHT Blocker", t: "Blocks the receptor they all act on, however the DHT got there.", tone: "ours" },
          { at: "enzyme", h: "Finasteride", t: "Blocks testosterone turning into DHT. DHT-derived compounds skip this step completely.", tone: "warn" }
        ]
      },
      proof: {
        title: "You're not the only one [[protecting your hairline on cycle]].",
        stats: [
          { n: "59%", t: "of enhanced lifters posting about hair loss already use or name finasteride or dutasteride.", src: "Folliva research: r/moreplatesmoredates, r/PEDs, r/SARMs, r/steroids, Oct 2025–Oct 2026" },
          { n: "1 in 5", t: "people looking for a receptor-level DHT blocker are enhanced lifters.", src: "Folliva research, Oct 2025–Oct 2026" }
        ],
        voice: "The same line comes up in every forum: not giving up the cycle, not giving up the hairline."
      },
      offer: {
        h: "Protect your hairline [[before your next cycle]].",
        sub: "A 5% topical DHT blocker that works at the receptor: the step finasteride can't cover.",
        size: "150 ml", sizeWhy: "150 ml is 90 days: start before your cycle and stay covered through it."
      },
      reasons: [
        { h: "Receptor-level", t: "Finasteride blocks one route to DHT. Folliva blocks the receptor, where DHT-derived compounds act too." },
        { h: "Start before you start", t: "The best time to protect your hairline is before your next cycle, not in week six." },
        { h: "Plain box, measured dose", t: "Ships in a plain box from inside the EU. A measured spray, so the dose is the same every night. Runs alongside finasteride." }
      ],
      note: "Running finasteride already? Keep it. Folliva covers a different step.",
      faq: [
        { q: "When should I start?", a: "Ideally a few weeks before your next cycle." },
        { q: "Can I run it with finasteride or dutasteride?", a: "Yes. They act at different steps." },
        { q: "Will it affect my gains?", a: "It's a topical made for the scalp, used at 1–1.5 ml a day. If you notice anything you don't like, stop and tell us." },
        { q: "Is it the same as powder?", a: "It's a ready-made 5% solution with a measured spray, so the dose is the same every day." }
      ]
    },

    natural: {
      name: "Beyond natural",
      tag: "Men who tried the gentle route first, and want something that does more.",
      gap: "Plant extracts are mild. DHT isn't.",
      inter: "Rosemary, saw palmetto, pumpkin seed. In the best-known trial, rosemary oil only [[matched 2% minoxidil]], the weakest strength. || If you've been consistent and you're still thinning, it's [[not your discipline]]. It's the strength of the tool.",
      mech: {
        title: "Gentle helps a little. [[DHT needs a direct block.]]",
        pins: [
          { at: "growth", h: "Rosemary, saw palmetto, pumpkin seed", t: "Mild effects in small studies. None of them blocks DHT at the follicle.", tone: "have" },
          { at: "receptor", h: "Folliva DHT Blocker", t: "Blocks DHT directly, at the follicle's receptor.", tone: "ours" },
          { at: "enzyme", h: "Finasteride", t: "The pill route: lowers DHT across your whole body, which is where its sexual side effects come from.", tone: "avoid" }
        ]
      },
      proof: {
        title: "It's not your discipline. [[It's the tool.]]",
        stats: [
          { n: "= 2%", t: "In a 100-man trial, rosemary oil did about as well as 2% minoxidil, the weakest strength.", src: "Panahi et al., SKINmed, 2015" },
          { n: "5%", t: "max strength: 50 mg of DHT blocker in every millilitre, printed on the label.", src: "" }
        ],
        voice: "Many men try the oils first. Most of them end up here."
      },
      offer: {
        h: "The next step after natural. [[No sexual side effects.]]",
        sub: "Honestly: it isn't natural. It's a targeted, max-strength 5% DHT blocker, and it doesn't lower your DHT or testosterone like finasteride does.",
        size: "100 ml", sizeWhy: "100 ml is 60 days: enough to get past the first, shedding-heavy weeks."
      },
      reasons: [
        { h: "Honest about what it is", t: "A targeted DHT blocker. Not a plant extract, and we won't pretend otherwise." },
        { h: "No sexual side effects", t: "It blocks DHT at the follicle without lowering your DHT the way finasteride does. That's where finasteride's side effects come from." },
        { h: "One step instead of five", t: "One spray at night instead of a drawer of oils and serums." }
      ],
      note: "",
      faq: [
        { q: "Is it natural?", a: "No, and we won't pretend it is. It's a targeted DHT blocker." },
        { q: "Can I keep using rosemary oil or my shampoo?", a: "Yes. Apply Folliva to a dry scalp at night." },
        { q: "What's in it?", a: "A 5% DHT blocker. The full ingredient list is on the product page." },
        { q: "How long until I see a difference?", a: "Judge it at three to six months, with photos in the same light." }
      ]
    },

    trt: {
      name: "TRT and your hairline",
      tag: "Men who got their energy back, and don't want to pay for it with their hair.",
      gap: "More testosterone means more DHT at the scalp.",
      inter: "TRT is doing exactly what it should: [[more testosterone]]. || In men with sensitive follicles, some of it becomes [[DHT at the scalp]]. That's why shedding often starts a few months in. || You shouldn't have to choose between [[your T]] and [[your hairline]].",
      mech: {
        title: "More T in. [[More DHT at the follicle.]]",
        pins: [
          { at: "growth", h: "Thinner hair, every cycle", t: "More DHT at the follicle shortens each growth cycle, so hair grows back finer.", tone: "info" },
          { at: "receptor", h: "Folliva DHT Blocker", t: "Blocks DHT at the follicle. It doesn't lower your testosterone, so your TRT keeps doing its job.", tone: "ours" },
          { at: "enzyme", h: "TRT", t: "More testosterone in, so more of it turns into DHT.", tone: "warn" }
        ]
      },
      proof: {
        title: "Keep the T. [[Protect the hairline.]]",
        stats: [
          { n: "+122%", t: "rise in testosterone prescriptions for US men aged 18–34 since 2018.", src: "Epic Research; Truveta" },
          { n: "24%", t: "of men on TRT who post about hair loss fear finasteride or have had side effects on it.", src: "Folliva research: r/Testosterone, r/trt, Oct 2025–Oct 2026" }
        ],
        voice: "The forced choice comes up again and again: low T with hair, or high T with less hair."
      },
      offer: {
        h: "Protect your hairline. [[Keep your T.]]",
        sub: "A 5% topical DHT blocker that doesn't lower your testosterone. It blocks DHT where it shrinks hair.",
        size: "100 ml", sizeWhy: "100 ml is 60 days: enough to get past the first, shedding-heavy weeks."
      },
      reasons: [
        { h: "Leaves your testosterone alone", t: "It doesn't lower testosterone or stop it turning into DHT. TRT keeps doing its job." },
        { h: "Works where the damage happens", t: "DHT shrinks follicles at the receptor. That's where Folliva blocks it." },
        { h: "Fits your protocol", t: "One spray routine at night. Show this page to your clinic if you want a second opinion." }
      ],
      note: "Using HCG or enclomiphene? Check with your clinic before adding anything new.",
      faq: [
        { q: "Will it affect my libido?", a: "It doesn't lower your testosterone or your body's DHT. That's the difference from finasteride. If you notice anything you don't like, stop and tell us." },
        { q: "Can I use it with HCG or enclomiphene?", a: "There are no interaction studies for this combination. Ask your clinic." },
        { q: "Can I use it with minoxidil?", a: "Yes. Minoxidil in the morning, Folliva at night." },
        { q: "How long until I see a difference?", a: "Judge it at three to six months, with photos in the same light." }
      ]
    },

    notnow: {
      name: "Not right now, and that's OK",
      tag: "Men planning a family.",
      gap: "Not the time to start an antiandrogen.",
      inter: "Trying for a baby changes the plan. || [[We won't tell you]] any DHT blocker, ours included, is right while you're trying to conceive, and an honest brand won't. [[Talk to your doctor first.]] Here's what you can do meanwhile.",
      hold: {
        h: "We'd hold off for now.",
        p: "Antiandrogens, including ours, haven't been studied around conception or pregnancy, and a partner can be exposed through skin contact. Talk to your doctor before starting any DHT blocker.",
        meanwhile: [
          "Take baseline photos now: same light, same angle. You'll want them later.",
          "Look after the basics: sleep, stress, a gentle shampoo.",
          "Come back when the timing is right. Your analysis will still make sense."
        ],
        remind: "Get tips while you wait",
        contact: "Questions? Write to us"
      },
      faq: []
    }
  }
};
